/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/17
 */
const prefix = '/';

// 获取分类列表
export const getCategory = `${prefix}p/category/list`;

export const getProductOption = `${prefix}pp/`;

// 获取首页数据
export const getHome = `${prefix}p/list`;

// 获取热门回收商品数据
export const getHot = `${prefix}p/hot`;

// 获取商品
export const getProduct = `${prefix}p/list`;

export const toEvaluate = `${prefix}inquiry`;

// 搜索商品
export const queryProduct = `${prefix}p/search`;

// 搜索词自动补全
export const searchTip = `${prefix}p/expand`;

// 页面基础配置数据
export const pageInfo = `${prefix}pageinfo/index`;

export const toOrder = `${prefix}order`;



// WEBPACK FOOTER //
// ./src/config/urls.js